import './index.css'

import { LuSlidersHorizontal } from '@react-icons/all-files/lu/LuSlidersHorizontal'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { updateUserSettingsUnsafe } from '@disco/state-management/actions/ExplorerActions'
import { getUser } from '@disco/state-management/selectors/user'
import { groupSortOptions } from '@disco/utils/groups'

import enhanceWithClickOutside from 'utils/enhance-with-click-outside'

import { IconButton } from 'components/ds'
import Popover from 'components/ui/popover'

class ChannelSortDropdown extends Component<any> {
  state = {
    dropdownVisible: false,
  }
  _toggleDropdown = () =>
    this.setState({
      dropdownVisible: !this.state.dropdownVisible,
    })
  _handleOptionClick = option => {
    this.onSortChange(option.value[0], option.value[1])
  }

  handleClickOutside() {
    this.setState({
      dropdownVisible: false,
    })
  }

  onSortChange = (sortParam, sortDirection) => {
    this.props.updateUserSettingsUnsafe({
      settings: {
        channels_sort_param: sortParam,
        channels_sort_direction: sortDirection,
      },
    })
  }

  render() {
    const { channels_sort_param, channels_sort_direction } =
      this.props.user.settings
    const options = groupSortOptions.map(option => {
      const selected =
        channels_sort_param === option.sortParam &&
        channels_sort_direction === option.sortDirection
      return {
        label: option.title,
        value: [option.sortParam, option.sortDirection],
        selected: selected,
      }
    })
    return (
      <IconButton
        variant="ghost"
        color="gray"
        onClick={this._toggleDropdown}
        className="ChannelSort_Dropdown"
      >
        <LuSlidersHorizontal size={16} />
        {this.state.dropdownVisible && (
          <Popover
            compact
            items={options as any}
            onClick={this._handleOptionClick}
          />
        )}
      </IconButton>
    )
  }
}

const sortDropdown = enhanceWithClickOutside(ChannelSortDropdown)
export default connect(
  state => ({
    user: getUser(state),
  }),
  {
    updateUserSettingsUnsafe,
  },
)(sortDropdown)
